import { render, staticRenderFns } from "./PhdProposalCp.vue?vue&type=template&id=00d0b9b4&scoped=true&"
import script from "./PhdProposalCp.vue?vue&type=script&lang=js&"
export * from "./PhdProposalCp.vue?vue&type=script&lang=js&"
import style0 from "./PhdProposalCp.vue?vue&type=style&index=0&id=00d0b9b4&prod&scoped=true&lang=scss&"
import style1 from "./PhdProposalCp.vue?vue&type=style&index=1&id=00d0b9b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d0b9b4",
  null
  
)

export default component.exports